<!-- <div class="heading-text uni-heading-text d-flex justify-space-between" *ngIf="pageType!=='geoPlayback'">Geo Trace</div>
<hr *ngIf="pageType!=='geoPlayback'"> -->
<mat-card class="vehicle-box-playback" [ngClass]="{'h-31': isCollapsed}" *ngIf="type !== 'playbackV2'">
  <div class="geo-trace-top" [ngClass]="{'selected-trip': isTripSelected  }">
    <div class="d-flex gap5">
      <div class="trip-title">{{tripName??'--'}} |</div><div class="entity-title">{{tripId ?? entityName}}</div><div class="ml-3 mtrip-2">
        <div class="position-relative"><img src="../../../../assets/images/bell-icon-new.svg" [ngClass]="activeAlertsCount ? 'bell-icon-filter' : ''" alt="" class="img-fluid h-80">
        </div><sup class="alert-count" *ngIf="activeAlertsCount > 0">{{ activeAlertsCount ? activeAlertsCount : 0 }}</sup>
        <div (click)="openOptimizationSummary()" *ngIf="pageType !== 'geoPlayback' && _sharedService.rbacManagement('vehicles_Enrolled_PrescriptiveInsights') && entityDetails?.enablePrescriptiveInsights && insightsAvailable && showPrescritiveInsights" class="cursor"><img src="../../../../assets/images/general-ai-button.svg" alt="ai" class="img-fluid h-80"></div>
      </div>
    </div>
    <div class="make-responsive-trip-history" *ngIf="!isCollapsed">
      <div>
        <div class="stat-title">Distance</div>
        <div class="stat-value">{{ distanceTravelled ? (distanceTravelled)?.toFixed(2) : '---' }} <span class="stat-uom">km</span></div>
      </div>
      <div>
        <div class="stat-title">Duration</div>
        <div class="stat-value">{{ timeTaken ? (timeTaken | duration) : '---' }}</div>
      </div>
      <div>
        <div class="stat-title">Avg Speed</div>
        <div class="stat-value">{{ (tripDetails?.avgSpeed || tripDetails?.avgSpeed === 0) ? ((tripDetails?.avgSpeed)? (tripDetails?.avgSpeed)?.toFixed(2) : 0)  : '--' }}<span class="stat-uom">km/hr</span></div>
      </div>
      <div>
        <div class="stat-title">Max Speed</div>
        <div class="stat-value">{{ (tripDetails?.topSpeed || tripDetails?.topSpeed === 0) ? (tripDetails?.topSpeed ? (tripDetails?.topSpeed)?.toFixed(2) : 0)  : '--' }}<span class="stat-uom">km/hr</span></div>
      </div>
    </div>
    <div *ngIf="!isCollapsed">
    </div>
  </div>
  <div class="geo-trace-bottom" *ngIf="!isCollapsed">
    <div>
      <ul class="vehicle-location-summary-playback vehicle-location-summary mb-0">
        <li><span class="trip-date">{{tripStartDate ? tripStartDate  : '--'}}</span><span><img src="../../../../assets/images/location-start.svg" alt="" class="img-fluid h-80"></span><span class="location-details" [title]="startLocation ?? '--'" [ngClass]="{'location-ellipsis-trips':pageType!=='geoPlayback', 'location-ellipsis': pageType==='geoPlayback'}">{{
            startLocation ? startLocation : "--" }}</span></li>
        <li class="dashed-border-vertical"></li>
        <li><span class="trip-date">{{tripEndDate ? tripEndDate  : '--'}}</span><span><img src="../../../../assets/images/location-marker.svg" alt="" class="img-fluid h-80"></span><span class="location-details" [title]="endLocation ?? '--'" [ngClass]="{'location-ellipsis-trips':pageType!=='geoPlayback', 'location-ellipsis': pageType==='geoPlayback'}">{{
            endLocation ? endLocation : "--" }}</span></li>
      </ul>
    </div>
    <div class="align-items-center d-flex" *ngIf="pageType!=='geoPlayback' && tripDetails && _sharedService?.rbacManagement('vehicles_Enrolled_GeoTracePlayback')" (click)="geoTracePlayback()">
      <img src="../../../../assets/images/Geo-Playback.svg" alt="">
    </div>
    <div class="align-items-center d-flex" *ngIf="pageType!=='geoPlayback' && tripDetails && _sharedService?.rbacManagement('vehicles_Enrolled_GeoTracePlaybackV2')" (click)="geoTracePlaybackV2()">
      <img src="../../../../assets/images/Geo-Playback.svg" alt="">
    </div>
  </div>
</mat-card>

<!--Changed the design-->
<mat-card class="vehicle-box" *ngIf="false">
  <div class="d-flex align-items-center">
    <div>
      <div class="trip-date">{{ tripStartDate ? tripStartDate : '--' }}</div>
      <ul class="vehicle-time-locator p-0">
        <li><img src="../../../../assets/images/ph_clock-fill.svg" alt="" class="img-fluid h-80"></li>
        <li>{{ timeTaken ? (timeTaken | duration) : '---' }}</li>
        <li><img src="../../../../assets/images/car-icons.svg" alt="" class="img-fluid h-80"></li>
        <li>{{ (distanceTravelled || distanceTravelled === 0) ? (distanceTravelled ? (distanceTravelled+'Km') : '0 Km')  : '---' }}</li>
      </ul>
    </div>
    <div class="d-flex align-items-center ml-auto">
      <div class="filter-btn cursor mt-30" *ngFor="let btn of buttonList;let i =index;">{{ filterDate ? filterDate :
        btn?.name }}</div>
      <div class="ml-3 mt-30">
        <div class="position-relative"><img src="../../../../assets/images/bell-icon-new.svg" [ngClass]="activeAlertsCount ? 'bell-icon-filter' : ''"  alt="" class="img-fluid h-80">
        </div><sup class="vehile-alert-count" *ngIf="activeAlertsCount > 0">{{  activeAlertsCount ? activeAlertsCount : 0 }}</sup>
      </div>
    </div>
  </div>
  <ul class="vehicle-location-summary">
    <li><span><img src="../../../../assets/images/start-location-icon.svg" alt="" class="img-fluid h-80"></span><span class="location-ellipsis">{{
        startLocation ? startLocation : "--" }}</span></li>
    <li class="dashed-border-vertical"></li>
    <li><span><img src="../../../../assets/images/locator icon -blue.svg" alt="" class="img-fluid h-80"></span><span class="location-ellipsis">{{
        endLocation ? endLocation : "--" }}</span></li>
  </ul>
  <ul class="vehicle-data-container">
    <li>
      <ul class="vehicle-data-summary">
        <li>Top Speed</li>
        <li>{{ (tripDetails?.topSpeed || tripDetails?.topSpeed === 0) ? (tripDetails?.topSpeed ? (tripDetails?.topSpeed)?.toFixed(2) : 0)  : '--' }} Km/hr</li>
      </ul>
    </li>
    <li>
      <ul class="vehicle-data-summary">
        <li>Average Speed</li>
        <li>{{ (tripDetails?.avgSpeed || tripDetails?.avgSpeed === 0) ? ((tripDetails?.avgSpeed)? (tripDetails?.avgSpeed)?.toFixed(2) : 0)  : '--' }} Km/hr</li>
      </ul>
    </li>
    <li>
      <!-- <ul class="vehicle-data-summary">
        <li>Time in idle State</li>
        <li>00:00:00</li>
      </ul> -->
      <ul class="vehicle-data-summary">
        <li>Hard acceleration</li>
        <li>--</li>
      </ul>
    </li>
    <li>
      <ul class="vehicle-data-summary">
        <li>Hard Braking</li>
        <li>--</li>
      </ul>
    </li>
  </ul>
</mat-card>
<!--Changed the design-->

<!-- new design for version 2 -->
<div class="playback-v2-container" *ngIf="type === 'playbackV2'">
  <div class="d-flex justify-space-between">
    <div class="d-flex gap-10">
      <span class="playback-v2-header">Trip Summary</span>
      <div class="position-relative"><img src="../../../../assets/images/bell-icon-new.svg"
          [ngClass]="activeAlertsCount ? 'bell-icon-filter' : ''" alt="" class="img-fluid h-80">
      </div><sup class="alert-count" *ngIf="activeAlertsCount > 0">{{ activeAlertsCount ? activeAlertsCount : 0 }}</sup>
    </div>
    <div class="d-flex gap-1 cursor" (click)="switchAnalysisDrawer(true)">
      <img src="../../../../assets/images/playback-analysis-drawer-icon.svg" alt="" class="img-fluid">
      <span class="playback-analysis-label">Analysis</span>
    </div>
  </div>
  <div class="mt-3">
    <div>
      <div class="playback-v2-stat-title-chassis">Vehicle Chassis Number</div>
      <div class="playback-v2-stat-value-chassis">{{ entityName }} </div>
    </div>
    <div class="playback-v2-responsive-trip-details mt-2">
      <div>
        <div class="playback-v2-stat-title">Distance</div>
        <div class="playback-v2-stat-value">{{ distanceTravelled ? (distanceTravelled)?.toFixed(2) : '---' }} <span
            class="stat-uom">km</span></div>
      </div>
      <div>
        <div class="playback-v2-stat-title">Duration</div>
        <div class="playback-v2-stat-value">{{ timeTaken ? (timeTaken | duration) : '---' }}</div>
      </div>
      <div>
        <div class="playback-v2-stat-title">Avg Speed</div>
        <div class="playback-v2-stat-value">{{ (tripDetails?.avgSpeed || tripDetails?.avgSpeed === 0) ? ((tripDetails?.avgSpeed)?
          (tripDetails?.avgSpeed)?.toFixed(2) : 0) : '--' }}<span class="stat-uom"> km/hr</span></div>
      </div>
      <div>
        <div class="playback-v2-stat-title">Max Speed</div>
        <div class="playback-v2-stat-value">{{ (tripDetails?.topSpeed || tripDetails?.topSpeed === 0) ? (tripDetails?.topSpeed ?
          (tripDetails?.topSpeed)?.toFixed(2) : 0) : '--' }}<span class="stat-uom"> km/hr</span></div>
      </div>
    </div>
  </div>
  <hr class="playback-hr">

  <div>
    <div class="d-flex gap-10 align-items-center">
      <span class="playback-route-details-label">Route Details</span>
      <div *ngIf="_sharedService.rbacManagement('vehicles_Enrolled_PrescriptiveInsights') && entityDetails?.enablePrescriptiveInsights && tripInsightsData?.length" (click)="getTrips()" class="cursor">
        <img src="../../../../assets/images/general-ai-button.svg" alt="ai"
        class="cursor">
      </div>
    </div>
    <div class="route-details-section">
      <div class="d-flex gap-10">
      <img src="../../../../assets/images/playback-start-location-icon.svg" alt="" class="img-fluid">
      <span class="start-location-label">Start Location</span>
      </div>
      <div class="playbackv2-start-location">{{ startLocation ? startLocation : "--" }}</div>
      <div class="playback-v2-trip-date" *ngIf="tripStartDate; else noDate">
        {{ tripStartDate?.split(',')[0] }}
        <span class="dot-separator"> • </span>
        {{ tripStartDate?.split(',')[1].trim() }}
      </div>
      <ng-template #noDate> -- </ng-template>
    </div>

    <div class="route-details-section">
      <div class="d-flex gap-10">
      <img src="../../../../assets/images/playback-end-location-icon.svg" alt="" class="img-fluid">
      <span class="start-location-label">End Location</span>
      </div>
      <span class="playbackv2-start-location">{{ endLocation ? endLocation : "--" }}</span>
            <div class="playback-v2-trip-date" *ngIf="tripStartDate; else noDate">
        {{ tripEndDate?.split(',')?.[0] }}
        <span class="dot-separator"> • </span>
        {{ tripEndDate?.split(',')?.[1]?.trim() }}
      </div>
      <ng-template #noDate> -- </ng-template>
    </div>
  </div>
    <hr class="playback-hr">
</div>

  <app-trip-drawer *ngIf="type === 'playbackV2'" [isOpen]="isAiDrawerOpen" [entityDetails]="entityDetails" [tripData]="tripItems" [summaryData]="summaryData" [title]="drawerTitle"
    [subtitle]="drawerSubtitle" (closeDrawer)="closeDrawer()" (itemClick)="onTripItemClick($event)">
  </app-trip-drawer>